module.exports = __webpack_public_path__ + "static/media/joinusFood5.d6dfdba8.jpg";